import React from 'react';
import { graphql, useFragment } from 'react-relay';
import { AnalyticsContext } from '@atlaskit/analytics-next';
import { isExternalResource } from '@atlassian/help-center-common-util/is-external-resource';
import HelpObjectArticle from '../../../topics/src/common/ui/help-object-article';
import HelpObjectChannel from '../../../topics/src/common/ui/help-object-channel';
import HelpObjectRequestForm from '../../../topics/src/common/ui/help-object-request-form';
import type { helpObject_HelpCenterHelpObject$key } from './__generated__/helpObject_HelpCenterHelpObject.graphql';

const HelpObject = (props: { helpObject: helpObject_HelpCenterHelpObject$key }): JSX.Element | null => {
    const data = useFragment<helpObject_HelpCenterHelpObject$key>(
        graphql`
            fragment helpObject_HelpCenterHelpObject on HelpCenterHelpObject {
                __typename
                ... on HelpObjectStoreRequestForm {
                    ...helpObjectRequestForm_HelpObjectStoreRequestForm
                    entityKey
                    hidden
                }
                ... on HelpObjectStoreArticle {
                    ...helpObjectArticle_HelpObjectStoreArticle
                    entityKey
                    hidden
                }
                ... on HelpObjectStoreChannel {
                    ...helpObjectChannel_HelpObjectStoreChannel
                    entityKey
                    hidden
                }
            }
        `,
        props.helpObject
    );
    const type =
        data.__typename === 'HelpObjectStoreRequestForm' ||
        data.__typename === 'HelpObjectStoreArticle' ||
        data.__typename === 'HelpObjectStoreChannel'
            ? (data.entityKey as string)
            : '';
    const hidden =
        (data.__typename === 'HelpObjectStoreRequestForm' ||
            data.__typename === 'HelpObjectStoreArticle' ||
            data.__typename === 'HelpObjectStoreChannel') &&
        data.hidden;

    return hidden ? null : (
        <AnalyticsContext data={{ attributes: { isExternal: isExternalResource(type), type: data.__typename } }}>
            {data.__typename === 'HelpObjectStoreRequestForm' && <HelpObjectRequestForm helpObject={data} />}
            {data.__typename === 'HelpObjectStoreArticle' && <HelpObjectArticle helpObject={data} />}
            {data.__typename === 'HelpObjectStoreChannel' && <HelpObjectChannel helpObject={data} />}
        </AnalyticsContext>
    );
};

export default HelpObject;
